import 'css-chunk:src/feature/check-discount/CheckDiscountModal.module.scss';export default {
  "autoDiscount": "CheckDiscountModal_autoDiscount",
  "manualDiscount": "CheckDiscountModal_manualDiscount",
  "grid": "CheckDiscountModal_grid",
  "divider": "CheckDiscountModal_divider"
};